import * as React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MobileState {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}

function getWindowDimensions() {
    if (typeof window !== "undefined") {
        return window.innerWidth;
    }

    return 1024;
}

const initialState: MobileState = {
    isMobile: getWindowDimensions() <= 768,
    isTablet: 768 < getWindowDimensions() && getWindowDimensions() <= 1023,
    isDesktop: getWindowDimensions() > 1023,
};

export const mobileSlice = createSlice({
    name: "mobile",
    initialState,
    reducers: {
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload;
        },
        setisTablet: (state, action: PayloadAction<boolean>) => {
            state.isTablet = action.payload;
        },
        setIsDesktop: (state, action: PayloadAction<boolean>) => {
            state.isDesktop = action.payload;
        },
    },
});

export const { setIsMobile, setisTablet, setIsDesktop } = mobileSlice.actions;

export const selectIsMobile = (state: { mobile: MobileState }) =>
    state.mobile.isMobile;
export const selectisTablet = (state: { mobile: MobileState }) =>
    state.mobile.isTablet;
export const selectIsDesktop = (state: { mobile: MobileState }) =>
    state.mobile.isDesktop;

export default mobileSlice.reducer;
